export default __webpack_public_path__ + "media/images/icons/sign-in-alt-solid-a0ee99a3ac80c91d49acce07c804efa5.svg";